import { matchLocationToCityDatabase } from '../utils/locationMatcher';
import { handleLocationError } from '../utils/errorHandler';
import type { LocationState } from '../types';
import { CONFIG } from '../config';

export async function detectLocation(): Promise<LocationState> {
  try {
    // Use default location since we're removing Google Maps
    return {
      ...CONFIG.DEFAULT_LOCATION,
      loading: false
    };
  } catch (error) {
    console.error('Location detection error:', handleLocationError(error));
    return {
      ...CONFIG.DEFAULT_LOCATION,
      loading: false,
      error: 'Could not detect location'
    };
  }
}